import './AppDetailsPopover.scss';
import { AppDisplay } from './AppDisplay';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { coreActions } from '@sonar-software/sonar-core';
import { DetailSubsection } from '@periscopes/general';
import { SonarStakeholder } from '@ui/SonarStakeholder';
import { SonarUser } from '@ui/SonarUser';
import { StakeholderAvatarGroup } from '@ui/avatar';
import { Popover, Space } from 'antd';
import React from 'react';
import { useAction, useApplicationReference } from '@hooks';
export const AppDetailsPopover = ({ appId, children }) => {
    const { description, integrationUser, ownerId, stakeholderGroupId, stakeholderIds } = useApplicationReference(appId);
    const loadApp = useAction(coreActions.requestGetCoreDataSecurityApplicationsById);
    const content = React.createElement(React.Fragment, null,
        React.createElement(DetailSubsection, { title: COPY_SPECIFIC.NAME }, React.createElement(AppDisplay, { appId: appId })),
        React.createElement(DetailSubsection, { title: COPY_SPECIFIC.INTEGRATION_USER }, integrationUser),
        Boolean(description) &&
            React.createElement(DetailSubsection, { className: 'app-description', title: COPY_SPECIFIC.DESCRIPTION }, description),
        ownerId !== undefined && Boolean(ownerId) &&
            React.createElement(DetailSubsection, { title: COPY_SPECIFIC.OWNER },
                React.createElement(SonarUser, { showTooltip: true, userId: ownerId })),
        stakeholderIds !== undefined && Boolean(stakeholderIds.length) &&
            React.createElement(DetailSubsection, { title: COPY_SPECIFIC.STAKEHOLDERS },
                React.createElement(Space, { direction: 'vertical' },
                    stakeholderIds.slice(0, 3).map((id) => React.createElement(SonarStakeholder, { key: id, showTooltip: true, stakeholderId: id })),
                    stakeholderIds.length > 3 &&
                        React.createElement(StakeholderAvatarGroup, { maxCount: 5, stakeholders: stakeholderIds.slice(3).map((id) => ({ stakeholderId: id })) }))),
        stakeholderGroupId !== undefined && Boolean(stakeholderGroupId) &&
            React.createElement(DetailSubsection, { title: COPY_SPECIFIC.GROUP },
                React.createElement(SonarStakeholder, { showTooltip: true, stakeholderId: stakeholderGroupId })));
    return (React.createElement(Popover, { content: content, onOpenChange: (open) => {
            if (open && !integrationUser) {
                loadApp({ applicationId: appId });
            }
        }, overlayClassName: 'app-details-popover', placement: 'right' }, children));
};
